import React from "react";
import { Box } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import {
  VideoRowTitle,
  HorizontalScroll,
  MEMBERSHIP_COLORS,
} from "./MembershipStyles";
import VideoCard from "./VideoCard";

interface VideoData {
  id: string;
  title: string;
  duration: string;
  type: string;
  thumbnail: string;
  isLocked?: boolean;
}

interface VideoRowProps {
  title: string;
  videos: VideoData[];
}

const VideoRow: React.FC<VideoRowProps> = ({ title, videos }) => {
  return (
    <Box sx={{ mb: 6 }}>
      <VideoRowTitle>
        {title} <ChevronRight sx={{ color: MEMBERSHIP_COLORS.accent }} />
      </VideoRowTitle>
      <HorizontalScroll>
        {videos.map((video) => (
          <VideoCard key={video.id} {...video} />
        ))}
      </HorizontalScroll>
    </Box>
  );
};

export default VideoRow;
